import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const frStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'Inviter sur WhatsApp',
  NLSWhatsappInviteDialogTitle: 'Inviter sur WhatsApp',
  NLSWhatsappInviteDialogCopy: 'Copier le lien',
  NLSWhatsappInviteDialogShare: 'Partager',
  NLSWhatsappSendFromMineAction: 'Envoyer depuis mon WhatsApp',
  NLSWhatsappSendFromMineText: 'Bonjour {name}, c’est {sender} de {workspace}.',
  NLSWhatsappSlipQrCaption: 'Discutez avec nous sur WhatsApp',
  NLSWhatsappChipLinked: 'WhatsApp lié',
  NLSWhatsappChipNotYet: 'WhatsApp : pas encore',
  NLSWhatsappChipStopped: 'WhatsApp : arrêté',
  NLSEduAnnouncementSendWhatsappAction: 'Envoyer sur WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'Envoyer sur WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'Envoyer',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: 'Envoie à {n} tuteurs',
  NLSEduAnnouncementSendWhatsappSummaryCredits: 'Envoie à {n} tuteurs · environ {credits} crédits',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'Gratuit dans la limite de votre forfait',
  NLSEduAnnouncementSendWhatsappReasonOff: 'WhatsApp est désactivé pour cet espace.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: "L'envoi d'annonces admin est désactivé dans les paramètres.",
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: "Aucun tuteur avec consentement téléphonique vérifié n'a été trouvé.",
  NLSEduAnnouncementSendWhatsappReasonPaused: "L'envoi WhatsApp est suspendu en raison de crédits insuffisants.",
  NLSEduAnnouncementSentWhatsappCount: 'Envoyé sur WhatsApp à {count}',
  NLSCommonRailPageShellSidecarSheet: "Panneau de détails",
  NLSCommonActionBackToWorkspace: 'Retour espace',
  NLSCommonActionBack: 'Retour',
  NLSCommonActionCancel: 'Annuler',
  NLSCommonActionContinue: 'Continuer',
  NLSCommonActionSignOut: 'Se deconnecter',
  NLSCommonActionRetryLoadingWorkspaces: 'Reessayer les espaces',
  NLSCommonActionRetrying: 'Nouvel essai...',
  NLSCommonActionDownload: 'Telecharger',
  NLSCommonActionOpen: 'Ouvrir',
  NLSCommonActionReloadThisTab: 'Recharger l onglet',
  NLSCommonActionMarkUpInDesign: 'Annoter dans Design',
  NLSCommonAriaAccessDenied: 'Acces refuse',
  NLSCommonAriaClosePreview: 'Fermer l apercu',
  NLSCommonAriaConnectionStatus: 'Etat de connexion',
  NLSCommonAriaPreviewAttachment: 'Apercu de {label}',
  NLSCommonEmptyNoActions: 'Aucune action',
  NLSCommonEmptyNoOptions: 'Aucune option',
  NLSCommonErrorGeneric: 'Une erreur est survenue.',
  NLSCommonInputSearchPlaceholder: 'Rechercher',
  NLSCommonInputSearchEllipsisPlaceholder: 'Rechercher…',
  NLSCommonInputSearchOptionsPlaceholder: 'Rechercher options',
  NLSCommonInputSelectPlaceholder: 'Choisir',
  NLSCommonInputSelectEllipsisPlaceholder: 'Choisir…',
  NLSCommonStatusApi: 'API',
  NLSCommonStatusLoading: 'Chargement',
  NLSCommonLanguageAriaLabel: 'Langue de l app',
  NLSCommonLanguageLabel: 'Langue',
  NLSCommonAccessDeniedDefaultMessage: 'Votre role de compte ne peut pas acceder a cette zone.',
  NLSCommonAccessDeniedTitle: 'Acces refuse',
  NLSCommonConnectivityDescription: 'La derniere requete a echoue car cet appareil semble hors ligne. Reconnectez-vous puis reessayez l action. Votre espace reste ouvert dessous.',
  NLSCommonConnectivityEyebrow: 'Connexion interrompue',
  NLSCommonConnectivityRequestPaused: 'Requete en pause',
  NLSCommonConnectivityTitle: 'Timelining ne peut pas joindre le reseau.',
  NLSCommonPreviewAttachmentUnavailable: 'Piece jointe indisponible.',
  NLSCommonPreviewFormatUnavailable: 'L apercu n est pas disponible pour ce format ici. Vous pouvez encore ouvrir ou telecharger le fichier original.',
  NLSCommonPreviewKindAsset: 'Asset',
  NLSCommonPreviewKindAudio: 'Audio',
  NLSCommonPreviewKindDocument: 'Document',
  NLSCommonPreviewKindFile: 'Fichier',
  NLSCommonPreviewKindImage: 'Image',
  NLSCommonPreviewKindLink: 'Lien',
  NLSCommonPreviewKindSpreadsheet: 'Feuille',
  NLSCommonPreviewKindTimelineItem: 'Element timeline',
  NLSCommonPreviewKindVideo: 'Video',
  NLSCommonPreviewPreparingText: 'Preparation de l apercu...',
  NLSCommonPreviewTextBlocked: 'L apercu texte est bloque pour ce fichier. Ouvrez ou telechargez l original.',
  NLSCommonPreviewTextTruncated: 'Apercu tronque',
  NLSCommonTabErrorBody: 'Le reste de l app fonctionne. Utilisez les onglets du bas pour naviguer, ou rechargez cet onglet.',
  NLSCommonTabErrorTitle: 'Onglet en erreur',
  NLSAuthEyebrowCloudWorkspace: 'Espace cloud',
  NLSAuthEyebrowHelperAccess: 'Acces helper',
  NLSAuthTitleCloudWorkspace: 'Cartographiez vos objectifs. Ou ceux de votre equipe.',
  NLSAuthTitleHelperPhone: 'Connectez-vous avec votre telephone.',
  NLSAuthActionCheckSession: 'Verifier session',
  NLSAuthActionContinueGoogle: 'Continuer avec Google',
  NLSAuthActionOpeningGoogle: 'Ouverture de Google...',
  NLSAuthActionSendOtp: 'Envoyer OTP',
  NLSAuthActionSendingOtp: 'Envoi OTP...',
  NLSAuthActionVerifySignIn: 'Verifier et entrer',
  NLSAuthActionVerifying: 'Verification...',
  NLSAuthActionUseDifferentNumber: 'Autre numero',
  NLSAuthFieldPhoneNumber: 'Telephone',
  NLSAuthFieldVerificationCode: 'Code',
  NLSOnboardingEyebrowNewSpace: 'Un nouvel espace attend',
  NLSOnboardingTitleBegin: 'Ou voulez-vous commencer ?',
  NLSOnboardingPersonalTitle: 'Espace personnel',
  NLSOnboardingActionLaunchPersonal: 'Ouvrir espace personnel',
  NLSOnboardingTeamTitleCreate: 'Espace equipe',
  NLSOnboardingActionExploreTeam: 'Explorer les equipes',
  NLSOnboardingTabInvites: 'Invitations',
  NLSOnboardingTabDiscover: 'Decouvrir',
  NLSOnboardingTabCreateNew: 'Creer',
  NLSShellRailSectionBoard: 'Tableau',
  NLSShellRailSectionControls: 'Controles',
  NLSShellRailDays: 'jours',
  NLSShellRailPersonalWallet: 'Portefeuille perso',
  NLSShellRailTileDashboard: 'Tableau',
  NLSShellRailTileCalendar: 'Calendrier',
  NLSShellRailTileMembers: 'Membres',
  NLSShellRailTileSettings: 'Reglages',
  NLSShellRailTileNotifications: 'Notifications',
  NLSShellRailTileLogOut: 'Sortir',
  NLSOpsRequestKindReliefNeeded: 'Remplacement nécessaire',
  NLSOpsRequestKindIncident: 'Incident',
  NLSOpsRequestKindClientComplaint: 'Réclamation client',
  NLSOpsRequestKindSupplyRequest: 'Demande de fournitures',
  NLSOpsRequestKindPm: 'Maintenance préventive',
  NLSOpsRequestKindCalibration: 'Étalonnage',
  NLSOpsReliefNeededTitle: 'Remplacement nécessaire : {roleLabel} à {placeName} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'Postes de garde par site et quart · une absence génère une demande de remplacement',
  NLSOpsSitesSelectSite: 'Sélectionner le site',
  NLSOpsSitesDay: 'Jour',
  NLSOpsSitesSelectShift: 'Sélectionner le quart',
  NLSOpsSitesPostsBoardTitle: 'Postes et remplacements',
  NLSOpsSitesColPost: 'Poste',
  NLSOpsSitesColNeeds: 'Besoins',
  NLSOpsSitesColOnDuty: 'En service',
  NLSOpsSitesColState: 'État',
  NLSOpsSitesStateCovered: 'Couvert',
  NLSOpsSitesStateShort: 'Incomplet',
  NLSOpsSitesStateReliefNeeded: 'Remplacement requis',
  NLSOpsSitesStateReliefAssigned: 'Remplacement assigné',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'absent',
  NLSOpsSitesReliefInbox: 'Boîte des remplacements',
  NLSOpsSitesReliefFootnote: 'Une absence sur la liste déclenche automatiquement RELIEF_NEEDED et alerte sur la couverture (A6).',
  NLSOpsSitesFreeCandidates: 'Candidats disponibles :',
  NLSOpsSitesOffToday: "en congé aujourd'hui",
  NLSOpsSitesAssignBtn: 'Assigner',
  NLSOpsSitesAssignCandidateBtn: 'Assigner {name}',
  NLSOpsSitesAssignDialogTitle: 'Assigner un remplacement',
  NLSOpsSitesPrintPostSheet: 'Imprimer la feuille de poste',
  NLSOpsSitesNoPosts: 'Aucun poste configuré pour ce site.',
  NLSOpsSitesNoReliefNeeded: 'Aucun remplacement nécessaire.',
  NLSOpsSitesNoSites: 'Aucun site client trouvé.',
  NLSOpsSitesNoShifts: 'Aucun quart disponible.',
  NLSOpsSitesPostSheetTitle: 'Feuille de poste · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'Impossible d’assigner le remplacement : la demande n’est plus ouverte.',
  NLSOpsSitesErrorOnLeave: 'Impossible d’assigner le remplacement : la personne est en congé approuvé.',
  NLSOpsSitesErrorDoubleBooked: 'Impossible d’assigner : la personne est déjà assignée à ce quart.',
  NLSOpsSitesErrorRoleCeiling: 'Impossible d’assigner le remplacement : le rôle du membre empêche cette affectation.',
  NLSOpsSitesErrorGeneric: 'Échec de l’assignation du remplacement.',
  NLSOpsSitesErrorNotFound: 'Enregistrement ou demande introuvable.',
  NLSOpsSitesErrorMissingAttributes: 'La demande ne contient pas les attributs de remplacement requis.',
  NLSOpsSitesErrorInactivePerson: 'Impossible d’assigner le remplacement : la personne est inactive dans l’espace.',
  NLSOpsRequestsUnassigned: 'Non assigné',
  NLSOpsRequestsDetailUnassigned: 'Non assigné',
  NLSOpsSitesIncidentsSubtitle: 'Incidents (restreints) · plaintes clients · demandes de fournitures · audits du superviseur',
  NLSOpsSitesIncidentsTitle: 'Incidents',
  NLSOpsSitesRestrictedTag: 'restreint',
  NLSOpsSitesAuditScoresTitle: 'Scores d’audit du site',
  NLSOpsSitesSupervisorRegisterTag: 'registre du superviseur',
  NLSOpsSitesColSite: 'Site',
  NLSOpsSitesColLastAudit: 'Dernier audit',
  NLSOpsSitesColScore: 'Score',
  NLSOpsSitesRecordAuditBtn: 'Enregistrer un audit',
  NLSOpsSitesComplaintsSupplyTitle: 'Plaintes et demandes de fournitures',
  NLSOpsSitesNoIncidents: 'Aucun incident enregistré.',
  NLSOpsSitesNoComplaintsSupply: 'Aucune plainte ni demande de fournitures.',
  NLSOpsSitesNoAudits: 'Aucun audit enregistré.',
  NLSOpsSitesNoAuditTemplate: "Aucun modèle d'audit de site superviseur configuré.",
  NLSOpsSitesOpenTemplatesBtn: 'Ouvrir les modèles',
} satisfies NlsStringMap

export default frStringsNls
